import React from 'react'
import { Tabs } from 'antd';
import { NomenclaturaTab } from './NomenclaturaTab';

export const ContainerTabs = ({residentialData}) => {
  
    const { TabPane } = Tabs;
    return (
        <>
            <Tabs className='primary-tabs' defaultActiveKey="1">                
                <TabPane tab="ZONAS" key="1">
                    <NomenclaturaTab/>
                </TabPane>
            </Tabs>
        
        </>
    )
}
